import z from 'zod'

export const productDimensionSchema = z
  .object({
    productGroupCode: z.preprocess(
      value => (value === '' ? undefined : value),
      z.coerce
        .number('Productgroepcode moet een getal zijn.')
        .int('Productgroepcode moet een geheel getal zijn.')
        .min(1, 'Productgroepcode moet groter dan 0 zijn.')
    ),
    fustCode: z.preprocess(
      value => (value === '' ? undefined : value),
      z.coerce
        .number('Fustcode moet een getal zijn.')
        .int('Fustcode moet een geheel getal zijn.')
        .min(1, 'Fustcode moet groter dan 0 zijn.')
        .optional()
        .nullable()
    ),
    warehouseId: z.coerce
      .number('Vestiging is verplicht.')
      .min(0, 'Vestiging is ongeldig.'),
    depthInMM: z.preprocess(
      value => (value === '' ? undefined : value),
      z.coerce
        .number('Diepte in mm moet een getal zijn.')
        .int('Diepte in mm moet een geheel getal zijn.')
        .min(1, 'Diepte in mm moet groter dan 0 zijn.')
        .optional()
        .nullable()
    ),
    widthInMM: z.preprocess(
      value => (value === '' ? undefined : value),
      z.coerce
        .number('Breedte in mm moet een getal zijn.')
        .int('Breedte in mm moet een geheel getal zijn.')
        .min(1, 'Breedte in mm moet groter dan 0 zijn.')
        .optional()
        .nullable()
    ),
    heightInMM: z.preprocess(
      value => (value === '' ? undefined : value),
      z.coerce
        .number('Hoogte in mm moet een getal zijn.')
        .int('Hoogte in mm moet een geheel getal zijn.')
        .min(1, 'Hoogte in mm moet groter dan 0 zijn.')
        .optional()
        .nullable()
    ),
    depthInPercentage: z.preprocess(
      value => (value === '' ? undefined : value),
      z.coerce
        .number('Diepte in percentage moet een getal zijn.')
        .int('Diepte in percentage moet een geheel getal zijn.')
        .min(1, 'Diepte in percentage moet groter dan 0 zijn.')
        .max(9999, 'De breedte in percentage moet minder dan 4 cijfers zijn.')
        .optional()
        .nullable()
    ),
    widthInPercentage: z.preprocess(
      value => (value === '' ? undefined : value),
      z.coerce
        .number('Breedte in percentage moet een getal zijn.')
        .int('Breedte in percentage moet een geheel getal zijn.')
        .min(1, 'Breedte in percentage moet groter dan 0 zijn.')
        .max(9999, 'De breedte in percentage moet minder dan 4 cijfers zijn.')
        .optional()
        .nullable()
    ),
    heightInPercentage: z.preprocess(
      value => (value === '' ? undefined : value),
      z.coerce
        .number('Hoogte in percentage moet een getal zijn.')
        .int('Hoogte in percentage moet een geheel getal zijn.')
        .min(1, 'Hoogte in percentage moet groter dan 0 zijn.')
        .max(9999, 'De hoogte in percentage moet minder dan 4 cijfers zijn.')
        .optional()
        .nullable()
    ),
  })
  .refine(
    ({
      widthInMM,
      heightInMM,
      depthInMM,
      widthInPercentage,
      heightInPercentage,
      depthInPercentage,
    }) => {
      // Check if at least one dimension field has a value, return error if not
      const hasAtLeastOne = [
        depthInMM,
        widthInMM,
        heightInMM,
        depthInPercentage,
        widthInPercentage,
        heightInPercentage,
      ].some(val => val !== undefined && val !== null)

      return hasAtLeastOne
    },
    {
      message: 'Vul minimaal één afmeting in.',
      path: ['no-dimensions'],
    }
  )

export type ProductDimensionFormData = z.infer<typeof productDimensionSchema>
